import React, { useState, useMemo, useEffect } from "react";
import { FEATURES_LIST } from "./constants";
import {
  FeatureSectionContainer,
  SliderContainer,
  ArrowButton,
  ArrowIcon,
  FeatureContent,
  FeatureImage,
  FeatureTitle,
  FeatureDescription,
  CardContainer,
  ImageWrapper,
  OrangeLine,
  GreyLine,
} from "./styles";
import { HOMEPAGE_ANCHOR_CONTAINER_IDs } from "../../../../lib/constants";

const FEATURES_LIST_LENGTH = FEATURES_LIST.length;

const calcPrevIndex = (idx) =>
  (idx - 1 + FEATURES_LIST_LENGTH) % FEATURES_LIST_LENGTH;

const calcNextIndex = (idx) => (idx + 1) % FEATURES_LIST_LENGTH;

const Features = ({ isMobile }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isProgress, setIsProgress] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex(calcNextIndex);
    }, 7000);

    setIsProgress(false);
    const timeout = setTimeout(() => {
      setIsProgress(true);
    }, 50);

    return () => {
      clearTimeout(timeout);
      clearInterval(interval);
    };
  }, [currentIndex]);

  const handleNextSlide = () => {
    setCurrentIndex(calcNextIndex);
  };

  const handlePreviousSlide = () => {
    setCurrentIndex(calcPrevIndex);
  };

  const visibleFeatures = useMemo(() => {
    const prevIndex = calcPrevIndex(currentIndex);
    const nextIndex = calcNextIndex(currentIndex);

    return [
      {
        data: FEATURES_LIST[prevIndex],
        role: {
          isPrev: true,
        },
      },
      {
        data: FEATURES_LIST[currentIndex],
        role: {
          isCurrent: true,
        },
      },
      {
        data: FEATURES_LIST[nextIndex],
        role: {
          isNext: true,
        },
      },
    ];
  }, [currentIndex]);

  const currentFeature = FEATURES_LIST[currentIndex];

  return (
    <FeatureSectionContainer id={HOMEPAGE_ANCHOR_CONTAINER_IDs.features.key}>
      <CardContainer>
        {visibleFeatures.map(({ data, role }) => (
          <ImageWrapper key={data.title} $role={role}>
            <FeatureImage $isMobile={isMobile} $src={data} />
          </ImageWrapper>
        ))}
      </CardContainer>

      <SliderContainer>
        <ArrowButton onClick={handlePreviousSlide}>
          <ArrowIcon $variant="left" />
        </ArrowButton>

        <FeatureContent>
          <FeatureTitle>{currentFeature.title}</FeatureTitle>
          <FeatureDescription>{currentFeature.description}</FeatureDescription>
          <GreyLine />
          <OrangeLine $isProgress={isProgress} />
        </FeatureContent>

        <ArrowButton onClick={handleNextSlide}>
          <ArrowIcon $variant="right" />
        </ArrowButton>
      </SliderContainer>
    </FeatureSectionContainer>
  );
};

export default Features;
